// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__2DgyN","line1":"Footer_line1__x_qom","line2":"Footer_line2__1yUCv"};